<template>
  <div class="border border-gray-200 mb-6">
    <div class="bg-gray-200">
      <div class="uppercase text-base font-bold py-2 px-4" @click.prevent="showContent = !showContent">
        {{ title }}
        <i class="fas fa-plus text-gray-500" v-show="!showContent" v-if="expandable"></i>
        <i class="fas fa-minus text-gray-500" v-show="showContent" v-if="expandable"></i>
      </div>
    </div>
    <div class="py-2 px-2 flex flex-wrap" v-show="showContent">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
    expandable: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      showContent: !!this.active,
    }
  },
}
</script>
